
class MealPlanNonBag {

  constructor(product_id,moneyFormat,formselector,activeday,activemealtype) {
    this.product = JSON.parse($("#json-data-"+product_id).html());
    this.moneyFormat = moneyFormat;
    this.formselector = formselector;
    this.mealtypes = this.oldmealtype = activemealtype;
    
    this.mealday = activeday;
    this.variants ={};
    $(this.formselector).find("input[name='data-mealtype[]']").bind('change', this.onChangeMealtype.bind(this));
    $(this.formselector).find("input:checkbox[name=addon_productid]").bind('change', this.updatePriceValues.bind(this));
    $(this.formselector).find("input[name='properties[Which days of the week?]']").bind('change', this.onChangeDay.bind(this));
    $(this.formselector).find("input[name='days']").bind('change', this.onChangeDays.bind(this));
    $(this.formselector).find("#button-"+this.product.id).bind('click', this.validateAddOnProducts.bind(this));
    $(this.formselector).find("#stricky-button-"+this.product.id).bind('click', this.validateAddOnProducts.bind(this));
    if ($(window). width() < 480) {
   		 $(this.formselector).find(".program-tab ul li").bind('click', this.onChangeTab.bind(this));
    }
    this.prepareVariantData();
    this.selectVariant();
    this.onChangeDay();
    this.onChangeDays();
    $('.error').html('');
//     console.log(this.cart());
  }
  onChangeTab(c){
  	 console.log($(c.currentTarget).hasClass('active'));
    if($(c.currentTarget)&&!$(c.currentTarget).hasClass('active')){ //this is the start of our condition 
        
        $(this.formselector).find(".program-tab ul li").removeClass('active');           
        $(c.currentTarget).addClass('active');
		$(this.formselector).find(".length-program").addClass('d-none-m');
        $('#'+ $(c.currentTarget).data('id')).removeClass('d-none-m').fadeIn('slow');
     }
  }
  validateAddOnProducts(){
    $('.error').html('');
    var self=this;
	var formData = new FormData($(this.formselector)[0]);
    var id= formData.get('id');
    var startdate=formData.get('properties[Start Date]');
    var howmanydays=formData.get('properties[Which days of the week?]');
    var slot=formData.get('properties[Preferred Delivery Slot]');
    var dietProtocol=formData.get('properties[Which Diet Protocol?]');
    var addonformData = new FormData();

//     console.log(formData);console.log(formData.get('items'));
    var addonitems=[];
    var properties={};
    if(howmanydays!=''){
     	 properties['Which days of the week?']=howmanydays;
    }
    if(dietProtocol!=''){
     	 properties['Which Diet Protocol?']=dietProtocol;
    }
    if(startdate!=''){
     	 properties['Start Date']=startdate;
    }else{
      $('.error').html('Please select start date');
      $('input[name="properties[Start Date]"]').focus();
       return false;  
    }
    if(slot!=''){
     	 properties['Preferred Delivery Slot']=slot;
    }
 
    if(id!=''){
      var main={'quantity':1,'id':id};
       if(Object.keys(properties).length>0){
           main['properties']=properties;
        }
     	addonitems.push(main); 
        self.cartClear();
    }
   
    $(this.formselector).find('input:checkbox[name=addon_productid]:checked').each(function(){
//       			addonformData.append('quantity',$("#addon-quantity-"+$(this).val()).val());
//       			addonformData.append('id',$(this).val());
     			addonitems.push({'quantity':parseInt($("#addon-quantity-"+$(this).data('product_id')).val()),'id':$(this).val()});
    });
//      console.log(addonitems);
    if(addonitems.length>0){
      self.cartClear().then(response1 => {
       let formData = {
           'items': addonitems
          };
        var returndata = this.cartAddFromForm(formData).then(response => {
//           console.log(response);
       		 window.location.replace("/cart");
          return response;
        })
        .catch((error) => {
          console.error('Error:', error);
       });
      }).catch((error) => {
          console.error('Error:', error);
      });
    }

    return false;
  }
  cartClear(){
     var config = this.getDefaultRequestConfig();
      config.method = 'POST';
     return this.fetchJSON('/cart/clear.js', config);
  }
  cartAddFromForm(formData) {
 
  var config = this.getDefaultRequestConfig();
//   delete config.headers['Content-Type'];

  config.method = 'POST';
  config.body = JSON.stringify(formData);

  return this.fetchJSON('/cart/add.js', config);
}
  prepareVariantData(){
   	  let self=this;
    console.log(self.isBagInclude);
    let roots = this.product.variants.map(function(item) {
      var key=item.option1_handle+'-'+item.option2_handle;
      var price=item.price;
      item['savedAmount']=item.compare_at_price>0?item.compare_at_price-price:0;
      item['percentage']=item.compare_at_price>0?Math.ceil(((item['savedAmount'])*100)/item.compare_at_price):0;
     	  self.variants[key]=item;
      return item;
    });  
    console.log(self.variants);
  }
   fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  cart() {
    return this.fetchJSON('/cart.js', this.getDefaultRequestConfig());
  }
  getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json;'
        }
      })
    );
  }
  onChangeMealtype(){
   var str='';
    $.each($(this.formselector).find("input[name='data-mealtype[]']:checked"), function(){
        str+=" + "+$(this).val();
    });
    str = str.substring(3);
    this.mealtypes=str;
    this.selectVariant();
  }
  getVariantBaseValue(item){
  		if (item.option1==this.mealday&&item.option2==this.mealday) {
        return item.id;
      }
    return false;
  }
  onChangeDay(){
    var howmanyday=$(this.formselector).find("input[name='properties[Which days of the week?]']:checked").data('value');
    if(howmanyday==5&&(parseInt(this.mealday)==6||parseInt(this.mealday)==7)){
//   		  $(this.formselector).find('input[name="properties[How many days a week?]"][value="' + parseInt(this.mealday) + ' Days"]').prop('checked', true);
    	this.onChangeDays();
    }
    $(this.formselector).find(".mealday").html($(this.formselector).find("input[name='properties[Which days of the week?]']:checked").val());
  }
  
   onChangeDays(){
    $(this.formselector).find(".mealdays").html($(this.formselector).find("input[name='days']:checked").data('text'));
     this.mealday = $(this.formselector).find("input[name='days']:checked").val();
     var howmanyday=$(this.formselector).find("input[name='properties[Which days of the week?]']:checked").data('value');
//     if(parseInt(this.mealday)<=howmanyday){
//       this.onChangeDay();
//     }
     if(howmanyday==5&&(parseInt(this.mealday)==6||parseInt(this.mealday)==7)){
       $(this.formselector).find('input[name="days"][value="5 Days"]').prop('checked', true);
       this.mealday = $(this.formselector).find("input[name='days']:checked").val();
       $(this.formselector).find(".mealdays").html($(this.formselector).find("input[name='days']:checked").data('text'));
     }
        this.selectVariant();
//      }
  }
  selectVariant(){
    let self=this;
//     console.log(this.mealday);
    let key= this.mealday.replace(/\W+/g, "-").toLowerCase()+'-'+this.mealtypes.replace(/\W+/g, "-").toLowerCase();
    $(".mealtypeerror").hide();
    $("#Option--0").val(this.mealday);
    $("#Option--1").val(this.mealtypes);    
    this.variant=false;
    console.log(self.mealtypes);
    console.log(key);
    if(self.mealday!='' && self.mealtypes!=''){
        //       let roots = this.product.variants.map(function(item) {
        // // 		console.log(item);
        //           if (item.option1==self.mealday&&item.option2==self.mealtypes) {
        //            return self.variant=item;
        //         }
        //         return item;
        //       });
      self.variant = self.variants[key];
    }
    if(self.variant){
      $("#button-"+this.product.id).prop('disabled',false);      
      $("#stricky-button-"+this.product.id).prop('disabled',false);
      $("#productvariant-"+this.product.id).val(self.variant.id); 
      $("#Option--0").val(this.mealday);
      $("#Option--1").val(this.mealtypes); 
      this.updatePriceValues();
      this.oldmealtype = this.mealtypes;
      $(".total-sec").show();
    }else{
      $(".mealtypeerror").find('strong').html(this.mealtypes);
      $(".mealtypeerror").show();
      $(".total-sec").hide();
      $(this.formselector).find(".totalprice").html(this.formatMoney(0,'amount_no_decimals'));
      $("#button-"+this.product.id).prop('disabled',true);
      $("#stricky-button-"+this.product.id).prop('disabled',true);
    }	
  }
  updatePriceValues(){
     var self=this;
     var discountval = 0;
     var savedAmount = 0;
     var addprice=0;
     var addsavedAmount=0;
     var addcompareprice=0;
    this.updateAddons();
    if(!this.variant.compare_at_price){
       $(this.formselector).find(".was-price").hide();
       $(this.formselector).find(".savedmsg").hide();
    }else{
//        savedAmount = this.variant.compare_at_price-this.variant.price;
//        discountval= (((savedAmount)*100)/this.variant.compare_at_price)*100;
     
      if($(this.formselector).find('#related-item-'+this.product.id)!=undefined){
        	$(this.formselector).find('#related-item-'+this.product.id).find('input:checkbox[name=addon_productid]:checked').each(function(){
              var addp=self.getAddonPrice($(this).data('product_id'));
              addprice=addprice+(addp.price*parseInt(self.mealday));
              addcompareprice=addcompareprice+(addp.compare_at_price*parseInt(self.mealday));
              addsavedAmount=addsavedAmount+((addp.compare_at_price>0?addp.compare_at_price-addp.price:0)*parseInt(self.mealday));
              
            });
      }
      if(Math.round(this.variant.percentage)>0){
         $(this.formselector).find(".was-price").show();
         $(this.formselector).find(".savedmsg").show();
      }else{
        $(this.formselector).find(".was-price").hide();
         $(this.formselector).find(".savedmsg").hide();
      }
       $(this.formselector).find(".was-price").html(this.formatMoney(this.variant.compare_at_price+addcompareprice,'amount_no_decimals'));
       $(this.formselector).find(".amountpercentage").html(Math.round(this.variant.percentage)+'%');
       $(this.formselector).find(".amountsaved").html(this.formatMoney(this.variant.savedAmount+addsavedAmount,'amount_no_decimals'));
    }
    $(this.formselector).find(".actual-price").html(this.formatMoney(this.variant.price+addprice,'amount_no_decimals'));
    $(this.formselector).find(".totalprice").html(this.formatMoney(this.variant.price+addprice,'amount_no_decimals'));
    this.showDiscountPercentage();
  }
  showDiscountPercentage(){
    let self=this;
    if($(this.formselector).find(".switch-meal-days").length>0){
      	$(this.formselector).find(".switch-meal-days").each(function() {
          var key = $(this).find('input').val().replace(/\W+/g, "-").toLowerCase()+'-'+self.mealtypes.replace(/\W+/g, "-").toLowerCase();
  //        console.log(key);
 //          console.log(self.variants[key]);
          if(self.variants[key].percentage>0){
            console.log(self.variants[key].percentage);
            $(this).removeClass('no-off');
            $(this).find('.upto').show(); 
            $(this).find('.upto .text-span').html(self.variants[key].percentage+'% off');
          }else{
             $(this).addClass('no-off');
             $(this).find('.upto').hide();
          }
        });
    }
    
  }
  getAddonPrice(id){
    if($("#productjson-"+id)!=undefined){
    var addonProduct=JSON.parse($("#productjson-"+id).html());
//       console.log(addonProduct);
      if(addonProduct.variants!=undefined){
        if(Object.keys(addonProduct.variants).length>1){
            for (let key in addonProduct.variants) {
               if (addonProduct.variants.hasOwnProperty(key)) {
      //             console.log(addonProduct.variants[key]);
      //             console.log(this.variant.percentage);

                 if(parseInt(addonProduct.variants[key].title)==this.variant.percentage){
                   return addonProduct.variants[key];
                 }else if(this.variant.percentage==0){
                   return addonProduct.variants[key];
                 }
               }
             }
        }else{
          return addonProduct.variants[0];
        }
      }else{
        return addonProduct.price;
      }
    }
  }
  updateAddons(){
    let self=this;
   if($(this.formselector).find('#related-item-'+this.product.id)!=undefined){
      $(this.formselector).find('#related-item-'+this.product.id).find('.addon-day').text(parseInt(this.mealday));
      $(this.formselector).find('#related-item-'+this.product.id).find('.addon-quantity').val(parseInt(this.mealday));
      $(this.formselector).find('#related-item-'+this.product.id).find('.addon-quantity').each(function(){
        var addprice=self.getAddonPrice($(this).data('product_id'));
        $(this).data('id',addprice.id);
        $(this).data('price',addprice.price);
        $('#addon-label-'+$(this).data('product_id')+' .addon-price').text(self.formatMoney(addprice.price)); 
        $('#addon-'+$(this).data('product_id')).val(addprice.id);
        $('#addon-total-'+$(this).data('product_id')).find('b').text(self.formatMoney($(this).data('price')*$(this).val()));
      });
    } 
  }
   formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }
  formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString =  this.moneyFormat;
  
  

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = this.formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = this.formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = this.formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = this.formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
  
}
